(function () {
  angular.module("akitabox.room").run(states);

  /* @ngInject */
  function states(models, Router) {
    Router.configureStates([
      {
        state: "app.building.room",
        config: {
          abstract: true,
          url: "/" + models.ROOM.ROUTE_PLURAL + "/:roomId",
          template: '<div flex layout="column" layout-fill ui-view></div>',
          resolve: {
            room: getRoom,
          },
        },
      },
      {
        state: "app.building.rooms",
        config: {
          url: "/" + models.ROOM.ROUTE_PLURAL + "?q",
          templateUrl: "app/mobile/modules/room/list/list.html",
          controller: "RoomListController",
          controllerAs: "vm",
          reloadOnSearch: false,
          resolve: {
            query: getQuery,
          },
          data: {
            pageTitle: "Rooms",
          },
        },
      },
    ]);
  }

  // ------------------------
  //   Detail
  // ------------------------

  /** @ngInject */
  function getRoom(
    /* Third-party */
    $stateParams,
    /* Resolve */
    building,
    /* Services */
    RoomService
  ) {
    var params = {
      include_values: true,
    };
    var options = {
      includePinType: true,
    };
    return RoomService.getById(
      building._id,
      $stateParams.roomId,
      params,
      options
    );
  }

  // ------------------------
  //   List
  // ------------------------

  /** @ngInject */
  function getQuery(account, $stateParams) {
    return $stateParams.q;
  }
})();
